
import Send from "../../../assets/filled/Send.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SendIcon({ className, dataTestid = "SendIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Send data-testid={dataTestid} className={classes} {...rest} />
  );
}
